import { useEffect } from 'react';

export const useEffectDelay = (
  callback: () => void,
  deps: unknown[],
  delay: number,
) => {
  useEffect(() => {
    const id = setTimeout(callback, delay);
    return () => clearTimeout(id);
  }, deps);
};
